<template>
  <div 
    :id="'elem-' + config.id" 
    class="vue-event-calendar">
    <div v-if="ready">

      <transition name="fade">
        <router-view :key="$route.fullPath"></router-view>
      </transition>

    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      ready: false,
      error: false
    }
  },
  computed: {
    config () {
      return this.$options.config
    }
  },
  mounted () {
    this.ready = true
  }
}
</script>
